import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import RouterBuilder from "./RouterBuilder";
import "./assets/css/font-faces.css";
import "./assets/css/main.css";
import "./assets/css/mainQueries.css";
import DefaultHelmet from "./DefaultHelmet";

// Define the router outside the component if static
const router = createBrowserRouter(RouterBuilder());

const App = () => {
  return (
    <HelmetProvider>
      <DefaultHelmet />
      <RouterProvider router={router} />
    </HelmetProvider>
  );
};

export default App;
